import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export const useNullDate = () => {
  const { t } = useTranslation();

  const formatDate = (date) => {
    // Check for null, undefined, or empty string
    if (!date) {
      return t('nullDate');
    }

    // Check for default/zero date
    if (date === '0001-01-01T00:00:00') {
      return t('nullDate');
    }

    // Validate if the date is valid using dayjs
    if (!dayjs(date).isValid()) {
      return t('nullDate');
    }

    // Return formatted date if valid
    return dayjs(date).format('YYYY-MM-DD');
  };

  return formatDate;
};